import styled from 'styled-components';

export const OverflowContainer = styled.div`
  max-width: 60px;
  overflow-x: hidden;
`;

export const Container = styled.div`
  display: flex;
  transform: translateX(${props => `${props.translateValue}px`});
  transition: transform ${props => props.transitionValue}s ease-out;
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  margin: 0 3px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  flex-shrink: 0;

  &.shrunken {
    margin: 0.5px 3.5px;
    height: 5px;
    width: 5px;
  }

  &.active {
    background-color: white;
  }
`;
